<div class="component-wrapper">
  <div class="heading-wrapper">
    <p class="heading">{{ textConstants.IMPLEMENTATION_STATUS }}</p>
    <p class="subheading">{{ subheading }}</p>
  </div>

  <div class="fd-card-wrapper">
    <fd-is-card
      color="#503291"
      boxShadow="1px 1px 40px 5px rgba(80, 50, 145, 0.50)"
      text="Number of countries"
      [value]="data.numberOfCountries | number : '1.0-0' : 'fr'"
      [width]="cardWidths[0]"
    ></fd-is-card>

    <fd-is-card
      color="#EB3C96"
      boxShadow="1px 1px 40px 5px rgba(235, 60, 150, 0.50)"
      text="Solution requests"
      [value]="data.solutionReuquests | number : '1.0-0' : 'fr'"
      [width]="cardWidths[1]"
    ></fd-is-card>

    <fd-is-card
      color="#0F69AF"
      boxShadow="1px 1px 30px 5px rgba(15, 105, 175, 0.50)"
      text="Solutions in launch phase"
      [value]="data.countriesLaunchPhase"
      [width]="cardWidths[2]"
    ></fd-is-card>

    <fd-is-card
      color="#2DBECD"
      boxShadow="1px 1px 30px 5px rgba(45, 190, 205, 0.50)"
      text="Solutions in pre-launch phase"
      [value]="data.countriesPreLaunchPhase"
      [width]="cardWidths[3]"
    ></fd-is-card>

    <fd-is-card
      color="#D9D7D8"
      boxShadow="1px 1px 30px 5px rgba(217, 215, 216, 0.50)"
      text="Overall internal NPS"
      value="N/A"
      [width]="cardWidths[4]"
    ></fd-is-card>
  </div>
</div>
